export default (initialState = {}) => {
  return () => {
    return {
      _id: null,
      billing_branch: null,
      branch_state_code: "",
      billing_address: {
        address: "",
        city: "",
        state_code: "",
        state: "",
        zip: "",
      },
      dispatch_from_address: {
        address: "",
        city: "",
        state_code: "",
        state: "",
        zip: "",
      },
      fssai: "",
      autoptions: ["0", "2"],
      shipping_address: {
        address: "",
        city: "",
        state_code: "",
        state: "",
        zip: "",
      },
      transaction_series_name: "",
      ...initialState,
    };
  };
};
